import { sessionSharingPolicy, type SessionSharingPolicy } from '@reflex/shared';
import { useOrganization } from './useOrganization';

/**
 * The active org's ceiling on session sharing: which access levels a share
 * may confer, if any. Read straight off the org that rides the session
 * payload, so the share affordances know what the server will accept without
 * an extra request.
 *
 * The UI reflects this policy; it does not implement it. Every path that
 * opens a grant is refused server-side for the same reasons, so hiding the
 * share button is a courtesy, never the control.
 */
export function useSessionSharingPolicy(): SessionSharingPolicy {
  const { activeOrganization } = useOrganization();
  return sessionSharingPolicy(activeOrganization);
}
